import { createLoaderImp } from '../../../components/ozmoit/common/loader-imp';
import {
  getContinuousEducationCoursesAction,
  getContinuousEducationFormDataAction,
} from '../actions';

const {
  useLoader: useContinuousEducationFormDataLoader,
  LoaderProvider: ContinuousEducationFormDataLoaderProvider,
} = createLoaderImp({
  action: getContinuousEducationFormDataAction,
});

const {
  useLoader: useContinuousEducationCoursesLoader,
  LoaderProvider: ContinuousEducationCoursesLoaderProvider,
} = createLoaderImp({
  action: getContinuousEducationCoursesAction,
});

export {
  useContinuousEducationFormDataLoader,
  ContinuousEducationFormDataLoaderProvider,
  useContinuousEducationCoursesLoader,
  ContinuousEducationCoursesLoaderProvider,
};
